import {
  Dispatch,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from "react";
import * as H from "history";
import EstagioArtistsInicio from "./EstagioArtistaInicio";
import EstagioArtistaMenu from "./EstagioArtistaMenu";
import EstagioArtistaMinhaCarreira from "./EstagioArtistaMinhaCarreira";
import EstagioArtistaPlanoEstrategico from "./EstagioArtistaPlanoEstrategico";
import { isMobile } from "react-device-detect";
import { Loader } from "shared/components";
import { fetchArtistsByGenre } from "shared/service/RadarService";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUserCashAdvanceAvailable } from "explorer/reducers/adiantamentos";
import NewEstagioArtistaSemQuiz from "./NewEstagioArtistaSemQuiz";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import ModalTelefone from "shared/components/modais/estagio/ModalTelefone";
import { notifyFirstAccess, UserState } from "explorer/reducers/users";
import "./NewEstagioArtista.scss";
import { ArtistState } from "explorer/reducers/artistas";
import { useFlags } from "launchdarkly-react-client-sdk";
import { DistributionStatusEnum } from "shared/enums/DistributionStatusEnum";

export const SecaoContext = createContext<
  Dispatch<SetStateAction<"inicio" | "carreira" | "estrategico">>
>(() => {});

export interface EstagioArtistaProps {
  history: H.History<any>;
  artistByGenre?: any[];
}

const NewEstagioArtista: React.FC<EstagioArtistaProps> = (props) => {
  const { history } = props;
  const { userArtist, loading } = useSelector(
    (state: ArtistState) => state.artists
  );
  const {
    firstAccess,
    firstAccessNotified,
    loading: userLoading,
    shouldOpenTour,
  } = useSelector((state: UserState) => state.users);
  const [artistsByGenre, setArtistsByGenre] = useState<any[]>([]);
  const [secao, setSecao] = useState<"inicio" | "carreira" | "estrategico">(
    "inicio"
  );
  const { enableTour } = useFlags();
  const dispatch = useDispatch();

  useEffect(() => {
    const getArtistByGenre = async () => {
      if (userArtist?.genresStrm?.length) {
        const response: any = await fetchArtistsByGenre(
          userArtist?.genresStrm[0]
        );
        setArtistsByGenre(response);
      }
    };
    getArtistByGenre();
  }, [userArtist?.genresStrm]);

  useEffect(() => {
    dispatch(getLoggedUserCashAdvanceAvailable(false));
  }, [dispatch]);

  useEffect(() => {
    if (
      !loading &&
      !userLoading &&
      (userArtist?.stage || 0) > 0 &&
      !firstAccessNotified
    ) {
      dataLayerViewedEvent({
        ...tagManagerEvent.Home.S4A_HOME_DIAGNOSED,
        carreerStage: userArtist?.stage,
        approvedLimit: userArtist?.cashAdvanceEstimated?.amountUsd,
        alreadyCalculated:
          userArtist?.cashAdvanceEstimated?.successfullyEstimated,
        country: userArtist?.country,
        firstAccess: firstAccess,
        activeAdvanceContract: userArtist?.cashAdvanceSigned,
        activeDistributionContract:
          userArtist?.distribution.status === DistributionStatusEnum.Signed,
        userTest: userArtist?.internalTest,
      });

      dispatch(notifyFirstAccess());
    }
  }, [
    loading,
    userLoading,
    userArtist,
    dispatch,
    history,
    firstAccessNotified,
    firstAccess,
  ]);

  useEffect(() => {
    if (enableTour && shouldOpenTour) {
      history.push("/tour");
    }
  }, [enableTour, history, shouldOpenTour]);

  if (userArtist?.stage === 0 || loading) return <Loader.Simple />;

  if (!userArtist?.stage && !loading) return <NewEstagioArtistaSemQuiz />;

  return (
    // <div className={`estagio-novo ${isMobile && "mobile"}`}>
    <SecaoContext.Provider value={setSecao}>
      <ModalTelefone />
      <div className={`estagio-novo mobile ${!isMobile && "web"} `}>
        <EstagioArtistaMenu secao={secao} setSecao={setSecao} />

        {secao === "inicio" && <EstagioArtistsInicio history={history} />}
        {secao === "carreira" && (
          <EstagioArtistaMinhaCarreira
            history={history}
            artistByGenre={artistsByGenre}
          />
        )}
        {secao === "estrategico" && (
          <EstagioArtistaPlanoEstrategico history={history} />
        )}
      </div>
    </SecaoContext.Provider>
  );
};

export default NewEstagioArtista;
